import {initDynamicProductCarousel} from '../../UM-Base/lib/ABtestHelper';
export default class ABExperiment {
}